import { useSelector } from 'react-redux';

import { ATTENDANCE_CONTROL_USERS_TYPES } from '@src/constants/users';
import { useTimeTracker } from '@src/containers/App/TimeTracker/contexts/TimeTrackerProvider';
import { ACCESS_TYPES } from '@src/packages/utils';

const useIsSelfModeTimeTracker = () => {
  const { isFromOperonda } = useTimeTracker();
  const orgUser = useSelector(({ user }) => user.orgUser.data);
  const isAdmin = orgUser?.access === ACCESS_TYPES.ADMIN || orgUser?.access === ACCESS_TYPES.OWNER;
  
  const hasExternalUserInfo = !!orgUser?.externalUserInfo;
  const externalUserInfo = orgUser?.externalUserInfo;
  const isSupervisor = orgUser?.externalUserInfo?.access === ATTENDANCE_CONTROL_USERS_TYPES.SUPERVISOR;
  const supervisorThirdParty = isSupervisor && !isAdmin;
  
  const isExternalUser = hasExternalUserInfo && !isSupervisor;
  
  // NOTE: isSelfMode for third users or common users
  let isSelfMode = isAdmin ? false : !isSupervisor || isExternalUser;
  if (!isFromOperonda) {
    isSelfMode = false;
  }

  return { 
    isSelfMode, 
    isSupervisor,
    supervisorThirdParty,
    isRegularUser: !hasExternalUserInfo,
    isExternalUser,
    isAdmin,
    externalUserInfo,
  };
};

export default useIsSelfModeTimeTracker;